import React from 'react';

/**
 * superscriptText function for formatting the character
 * @method
 * @param {object} data - Passing required data as an argument
 */
export const superscriptText = ( data ) => {
  const { title, character, shouldAppend = true } = data || {};
  if( !title || !character ){
    return '';
  }
  const str = title.split( character );
  if( shouldAppend || str?.length > 1 ){
    return <>{ str[0] }<sup>{ character }</sup>{ str[1] }</>;
  }
  return <>{ str[0] }</>;
};